/**
 * Utility to fix message types in Firestore
 * Run from browser console: await window.fixMessageTypes('leadId')
 */

import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from './firebase';

export async function fixMessageTypes(leadId: string) {
  console.log(`Checking messages for lead: ${leadId}`);
  
  try {
    const messagesRef = collection(db, 'smsMessages');
    const q = query(messagesRef, where('matchedLeadId', '==', leadId));
    const snapshot = await getDocs(q);
    
    console.log(`Found ${snapshot.size} messages`);
    
    let fixedCount = 0;
    
    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      
      // Log current state
      console.log(`Message ${docSnap.id}:`);
      console.log(`  sendStyle: ${data.sendStyle}`);
      console.log(`  isOutbound: ${data.isOutbound}`);
      console.log(`  wasDowngraded: ${data.wasDowngraded}`);
      console.log(`  content: ${data.content?.substring(0, 40)}...`);
      
      // Fix logic: If outbound and currently 'sms' but not downgraded, assume it should be iMessage
      if (data.isOutbound && data.sendStyle === 'sms' && !data.wasDowngraded) {
        console.log(`  → Updating to imessage`);
        await updateDoc(doc(db, 'smsMessages', docSnap.id), {
          sendStyle: 'imessage'
        });
        fixedCount++;
      }
    }
    
    console.log(`✓ Fixed ${fixedCount} messages`);
    return { success: true, fixed: fixedCount, total: snapshot.size };
    
  } catch (error) {
    console.error('Error fixing messages:', error);
    return { success: false, error };
  }
}

// Make it available globally for console access
if (typeof window !== 'undefined') {
  (window as any).fixMessageTypes = fixMessageTypes;
}
